import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { JurisdictionsService } from '../../../../../services/api/general-settings/jurisdictions.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { InputFieldComponent } from '../../../../../components/form/input-field/input-field.component';
import { LanguageClientComponent } from '../../../../../components/form/language-client/language-client.component';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

import { SelectJurisdictionTypesComponent } from 'src/app/components/options/select-jurisdiction-types-field/select-jurisdiction-types-fieldcomponent';

@Component({
  selector: 'jurisdiction-form',
  imports: [InputFieldComponent, ReactiveFormsModule, LanguageClientComponent, NgbAlert, SelectJurisdictionTypesComponent],
  templateUrl: './jurisdiction-form.component.html',
  styleUrl: './jurisdiction-form.component.scss'
})
export class JurisdictionFormComponent implements OnInit, OnChanges {

 @Input() jurisdiction?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  typeOptions: { key: string; value: string }[] = [];

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private jurisdictionsService: JurisdictionsService
  ) { }


  ngOnInit(): void {
    this.form = new FormGroup({
      type: new FormControl('', [Validators.required]),
      code: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      languageId: new FormControl('', [Validators.required]),
    });

    this.typeOptions = [
      { key: 'National', value: 'National' },
      { key: 'Regional', value: 'Regional' }
    ];
  }

ngOnChanges(changes: SimpleChanges) {
    if (changes['jurisdiction'] && changes['jurisdiction'].currentValue) {
      this.form.patchValue({
        type: this.jurisdiction.type,
        code: this.jurisdiction.code,
        name: this.jurisdiction.name,
        languageId: this.jurisdiction.language.languageId,
      });
    }
  }


/**
   * *******************
   * Submit form methods
   * *******************
   */
showAlertInfo(type: string, message: string) {
  this.alertInfo = {
    show: true,
    type,
    message
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(() => {
    this.alertInfo.show = false;
  }, 3000);
}
updateValidationErrors(validationErrors: any) {
  this.formService.resetErrors(this.form);
  this.formService.setValidationErrors(this.form, validationErrors);
}
submitFormSuccess(response: any) {
  this.alertNotificationService.success('Operation completed successfully')
  this.showAlertInfo('success', 'Operation completed successfully');

  this.onSavedData.emit({
    success: true,
    response
  });
}
submitFormError(error: any) {

  if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
    this.updateValidationErrors(error.error.error.validationErrors);
  }
  else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
    this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
    this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
  }
  else {
    this.showAlertInfo('danger', error.error.error.message);
  }

  this.onSavedData.emit({
    success: false,
    error
  });

}
submitForm(): void {
  Object.keys(this.form.controls).forEach(key => {
    const control = this.form.get(key);
    control?.markAsTouched();
    control?.updateValueAndValidity();
  });

  if (this.form.valid) {
    const values = Object.assign(
      this.form.value,
      {
        tenantId: 1,
      },
    )

    this.alertInfo.show = false;
    this.formService.resetErrors(this.form);

    const serviceMethod = this.jurisdiction
      ? this.jurisdictionsService.update(this.jurisdiction.jurisdictionId, values)
      : this.jurisdictionsService.create(values);

    serviceMethod.subscribe({
      next: (response: any) => {
        this.submitFormSuccess(response);
      },
      error: (error: any) => {
        this.submitFormError(error);
      },
    });
  }
}
/**
 * *******************
 * Submit form methods
 * *******************
 */

  getJurisdictionTypeSelect(): FormControl { return this.getFormControl('type'); }
  getJurisdictionCodeInput(): FormControl { return this.getFormControl('code'); }
  getJurisdictionNameInput(): FormControl { return this.getFormControl('name'); }
  getJurisdictionLanguageInput(): FormControl { return this.getFormControl('languageId'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
